import { SearchCriteriaBase, ListRange } from '../../../../../common/models';
import { Language, ListQueryParam } from '../../../../../common/constants';
import { AllocationViewProfileRenderItems, LocalDate } from '../../../..';
import { NATURAL_NUMBER_PATTERN } from '../../../../../common';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

export enum Modes {
  DarkMode = 'DARK_MODE',
  LightMode = 'LIGHT_MODE',
}

export enum ProfileStatus {
  Updated = 'updated',
  Created = 'created',
  Pristine = 'pristine',
}

export class AllocationViewProfile {
  calendarViewLayout: string[];
  createdAt?: LocalDate;
  defaultProfile: boolean;
  highlightOutbound: boolean;
  id?: number;
  name: string;
  filterProfileId?: number;
  terminalViewLayout: AllocationViewProfileRenderItems[];
  driverViewHubId: number;
  driverViewDisplayedTiles = 3;
  scrollingFactor: number;
  driverViewIncludeTimeDisplay: boolean;
  driverViewDarkMode: boolean;
  driverViewDisplayLanguages: Language[];

  constructor(data?: AllocationViewProfile) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class AllocationViewProfileListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: AllocationViewProfileListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewProfileForm {
  constructor(
    model: AllocationViewProfile,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model?.id),
    public name: FormControl<string> = fb.control<string>(model?.name, Validators.required),
    public createdAt: FormControl<LocalDate> = fb.control<LocalDate>(model?.createdAt),
    public defaultProfile: FormControl<boolean> = fb.control<boolean>(model?.defaultProfile),
    public highlightOutbound: FormControl<boolean> = fb.control<boolean>(model?.highlightOutbound),
    public filterProfileId: FormControl<number> = fb.control<number>(model?.filterProfileId),
    public terminalViewLayout: FormControl<string[]> = fb.control<string[]>(
      model?.terminalViewLayout,
      Validators.required,
    ),
    public calendarViewLayout: FormControl<string[]> = fb.control<string[]>(
      model?.calendarViewLayout,
      Validators.required,
    ),
    public driverViewHubId: FormControl<number> = fb.control<number>(model.driverViewHubId, Validators.required),
    public driverViewDisplayedTiles: FormControl<number> = fb.control<number>(model.driverViewDisplayedTiles, [
      Validators.pattern(NATURAL_NUMBER_PATTERN),
    ]),
    public scrollingFactor: FormControl<number> = fb.control<number>(model.scrollingFactor, [
      Validators.pattern(NATURAL_NUMBER_PATTERN),
      Validators.required,
    ]),
    public driverViewIncludeTimeDisplay: FormControl<boolean> = fb.control<boolean>(model.driverViewIncludeTimeDisplay),
    public driverViewDarkMode: FormControl<boolean> = fb.control<boolean>(model.driverViewDarkMode),
    public driverViewDisplayLanguages: FormControl<Language[]> = fb.control<Language[]>(
      model.driverViewDisplayLanguages,
    ),
  ) {}
}

export class warehouseViewLayoutInformation {
  hubId: number;
  modes: Modes = Modes.DarkMode;

  constructor(params?: warehouseViewLayoutInformation) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class warehouseViewLayoutInformationForm {
  constructor(
    model: warehouseViewLayoutInformation,
    fb: FormBuilder = new FormBuilder(),
    public hubId: FormControl<number> = fb.control<number>(model.hubId, []),
    public modes: FormControl<Modes> = fb.control<Modes>(model.modes, []),
  ) {}
}

export class AllocationDriverViewProfile {
  hubId: number;
  numberOfTiles: number;
  scrollingDuration: number;
  webDriverViewStyle: string;
  includeTimeDisplay: boolean;
  hubName: string;
  automaticUliCleaningHours: number;
  timezone: string;
  language: string;
  twentyFourHourTime: boolean;
  driverViewDisplayLanguages: Language[];

  constructor(data?: AllocationDriverViewProfile) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
